interface CurrencyDisplayProps {
  value: number
  className?: string
  showSign?: boolean
}

export default function CurrencyDisplay({ 
  value, 
  className = '', 
  showSign = false 
}: CurrencyDisplayProps) {
  const formatCurrency = (amount: number): string => {
    const formatted = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Math.abs(amount))

    if (showSign && amount !== 0) {
      return amount > 0 ? `+${formatted}` : `-${formatted}`
    }

    return amount < 0 ? `-${formatted}` : formatted
  }

  const getColorClass = (): string => {
    if (value > 0) return 'text-green'
    if (value < 0) return 'text-red'
    return ''
  }

  return (
    <span className={`text-mono ${getColorClass()} ${className}`}>
      {formatCurrency(value)}
    </span>
  )
}